import { render, staticRenderFns } from "./epms1020.vue?vue&type=template&id=2f089ed6&scoped=true"
import script from "./epms1020.vue?vue&type=script&lang=js"
export * from "./epms1020.vue?vue&type=script&lang=js"
import style0 from "./epms1020.vue?vue&type=style&index=0&id=2f089ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f089ed6",
  null
  
)

export default component.exports